import { render, staticRenderFns } from "./Criticality.vue?vue&type=template&id=a6701f92&scoped=true&"
import script from "./Criticality.vue?vue&type=script&lang=js&"
export * from "./Criticality.vue?vue&type=script&lang=js&"
import style0 from "./Criticality.vue?vue&type=style&index=0&id=a6701f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6701f92",
  null
  
)

export default component.exports